import React, {useState} from 'react';

import {Select} from '@kit';

import {humanEnumeration} from '../../../../components/utils';
import {useCharacter} from '../character-context';
import {ALIGNMENTS} from '../model/alignments';
import {abilityLabel, skillLabel} from '../model/labels';
import {ChoiceField} from './choice-field';
import {FeatureDetails} from './feature-details';
import {PickList} from './pick-list';
import {SelectedTitle} from './step-layout';

import css from './master.module.css';

export const OriginStep: React.FC = () => {
	const {catalog, state, features, update} = useCharacter();
	const [isPicking, setPicking] = useState(false);
	const origin = state.originId ? catalog.getOrigin(state.originId) : undefined;

	const selectOrigin = (originId: string) => {
		update({originId});
		setPicking(false);
	};

	return (
		<>
			{!origin || isPicking ? (
				<PickList
					items={catalog.origins.map((entry) => ({
						id: entry.id,
						title: entry.title,
						caption: humanEnumeration(entry.abilities.map(abilityLabel)),
					}))}
					selectedId={origin?.id}
					onSelect={selectOrigin}
				/>
			) : (
				<>
					<SelectedTitle
						title={origin.title}
						backLabel="К списку происхождений"
						onBack={() => setPicking(true)}
					/>
					<dl className={css.originFacts}>
						<dt>Характеристики</dt>
						<dd>{humanEnumeration(origin.abilities.map(abilityLabel))}</dd>
						<dt>Умения в навыках</dt>
						<dd>{humanEnumeration(origin.skills.map(skillLabel))}</dd>
						{origin.toolId && (
							<>
								<dt>Умения в инструментах</dt>
								<dd>{catalog.getItem(origin.toolId)?.title || origin.toolId}</dd>
							</>
						)}
					</dl>
					<Select
						label="Мировоззрение"
						placeholder="Выберите…"
						items={ALIGNMENTS.map(({key, label}) => ({value: key, label}))}
						value={state.alignment ?? null}
						onChange={([alignment]) =>
							update({alignment: alignment == null ? undefined : String(alignment)})
						}
					/>
					{features.origin.map((instance) => (
						<React.Fragment key={instance.key}>
							<div className={css.choices}>
								{instance.choices.map((choice) => (
									<ChoiceField key={choice.key} choice={choice} />
								))}
							</div>
							{instance.children.map((child) => (
								<FeatureDetails key={child.key} instance={child} />
							))}
						</React.Fragment>
					))}
				</>
			)}
		</>
	);
};
